(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const selects = document.querySelectorAll(".terms-version-select select");

    selects.forEach(function (select) {
      if (!select) {
        return;
      }

      // Set the selected option based on current page URL
      const currentPath = window.location.pathname.replace(/\/$/, ""); // Remove trailing slash
      const options = select.querySelectorAll("option");
      let foundMatch = false;

      options.forEach(function (option) {
        const optionPath = option.value.replace(/\/$/, ""); // Remove trailing slash
        if (
          optionPath === currentPath ||
          optionPath + "/" === currentPath ||
          optionPath === currentPath + "/"
        ) {
          option.selected = true;
          foundMatch = true;
        }
      });

      // If no match found, select the first option (current version)
      if (!foundMatch && options.length > 0) {
        options[0].selected = true;
      }

      // Handle navigation when selection changes
      select.addEventListener("change", function () {
        const selectedUrl = this.value;

        if (selectedUrl && selectedUrl !== currentPath) {
          window.location.href = selectedUrl;
        }
      });
    });
  });
})();
